import urls from '../../../urls';
import { route } from '../../helpers';
import OrderStore from '../../../stores/OrderStore';
import { CheckoutStages } from '../../../constants/AppConstants';

module.exports = [
    route(CheckoutStages.AMAZON_PAY_MFA_SUCCESS, {
        getComponent(location, cb) {
            require.ensure([], () => {
                cb(null, () => null);
            }, 'payment');
        },

        onEnter(nextState, replace) {
            const currentOrder = OrderStore.getCurrent();
            replace(
                urls.location(CheckoutStages.PAYMENT_AMAZON_PAY, null, null, {
                    state: {
                        amazonPayMFASuccess: true,
                        isPostalDelivery: currentOrder.isPostalDelivery(),
                    },
                }),
            );
        }
    }),
    route(CheckoutStages.AMAZON_PAY_MFA_FAILURE, {
        getComponent(location, cb) {
            require.ensure([], () => {
                cb(null, () => null);
            }, 'payment');
        },

        onEnter(nextState, replace) {
            replace(
                urls.location(CheckoutStages.PAYMENT, null, null, {
                    state: {amazonPayMFAFailure: true},
                }),
            );
        }
    })
];



// WEBPACK FOOTER //
// ./src/routes/Checkout/Payment/AmazonPayMFA.js